/*import Courses from '../Data/Courses.json'*/
import '../Style/MainGrid.css';

export default function Teaching() {
  
  return (
    <div>
      <p>
        Under ssConstructions ...
      </p>
    </div>
    /*<div className="teaching-page">
      <h1>Teaching</h1>
      <p className="abstract">
        Dr. Chen Griner is passionate about delivering engaging, research-led
        education in communication systems and engineering fundamentals. Her
        teaching spans top institutions and a wide range of interdisciplinary
        technical subjects.
      </p>

      <h2>Courses</h2>
      <div className="course-list">
        {courses.map((course, index) => (
          <div className="course-row" key={index}>
            <div className="course-year">{course.year}</div>
            <div className="course-info">
              <strong>{course.institution}</strong><br />
              {course.course}<br />
              <em>{course.position}</em>
            </div>
          </div>
        ))}
      </div>
    </div>*/
  )
}
